export const MISSION_OPTIONAL_QUANTITY_LABELS = [
  "completar missao assim que iniciada",
];

const normalizeText = (value?: string) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export class MissionRequirementsTransformer {
  static isValueRequired(label?: string) {
    const normalized = normalizeText(label);
    if (!normalized) return true;
    return !MISSION_OPTIONAL_QUANTITY_LABELS.some((text) =>
      normalized.includes(text),
    );
  }

  static fallbackValue(label?: string) {
    return MissionRequirementsTransformer.isValueRequired(label) ? "" : "1";
  }

  static sanitizePositiveNumericValue(value: string) {
    const cleaned = value.replace(/[^0-9.,-]/g, "");
    if (!cleaned.trim()) return "";
    const parsed = parseFloat(cleaned.replace(",", "."));
    if (!Number.isFinite(parsed) || parsed <= 0) return "";
    return cleaned;
  }
}

export default MissionRequirementsTransformer;
